import { useGetPublicPendudukStatistikPendidikan } from '@tatatemplate/shared-lib'

export function usePendidikanStats() {
  return useGetPublicPendudukStatistikPendidikan({
    query: { queryKey: ['statistik', 'pendidikan'], staleTime: 5 * 60 * 1000, retry: 3 },
  })
}
